import { Fragment, useEffect } from "react"
import { Container, Table, Button, Stack } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Spinner } from "react-bootstrap"
import { Link } from "react-router-dom"
import { getUsers } from "./usersTableApi"
import { setPerformer } from "./usersTableSlice"
import React from "react"
import { useState } from "react"

export function UsersTable(props) {

    const log = useSelector((state) => state.login)
    const users = useSelector((state) => state.users)
    const dispatch = useDispatch()
    const [search, setSearch] = useState('');
    const [selectedRow, setSelectedRow] = useState(null)
    const handleSearch = (event) => {
        console.log(search)
        setSearch(event.target.value);
    };
    let navigate = useNavigate();

    useEffect(() => {
        if (!log.token || log.token.length === 0) {
            return navigate("/login");
        }
    })
    function setUser(row) {

    }


    function getRowProperty(index) {
        if (index == selectedRow) {
            return "table-primary"
        }
        return ""
    }
    function onSelectedRowAction(index, row) {
        if (selectedRow == index) {
            dispatch(setPerformer(row))
        } else {
            setSelectedRow(index)
        }
    }



    let info = (<Fragment>
        <Spinner animation="border" />
    </Fragment>)

    if (users.users.length > 0) {
        const rows = users.users.filter(row => row.username.includes(search)).map((row, index) => (
            <tr key={index} onClick={() => onSelectedRowAction(index, row)} className={getRowProperty(index)}>
                <td key={index}>{index + 1}</td>
                <td key={2 + index + row.id + row.first_name}>{row.first_name}</td>
                <td key={3 + index + row.id + row.last_name}>{row.last_name}</td>
                <td key={4 + index + row.id + row.post}>{row.post}</td>
            </tr>))
        console.log(rows)
        info = (<Table striped bordered hover size="sm" responsive="sm">
            <thead>
                <tr>
                    <th>№</th>
                    <th>Имя</th>
                    <th>Фамилия</th>
                    <th>Должность</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>)


    } else {
        if (log.token != "") {
            dispatch(getUsers(log.token))

        }

    }

    return (

        <Stack gap={4} className="col-md-6 mx-auto">
            <input className="form-control" list="datalistOptions" type="text" placeholder="поиск" onChange={handleSearch} />
            {info}
        </Stack>
    )
}
